import { resourcesApi } from 'services/api/resources/queries';
import { selectCurrentLocale } from 'services/slices/locale';
import { useAppSelector } from 'services/store';

export function useGetResourcesQuery() {
  const locale = useAppSelector(selectCurrentLocale);
  return resourcesApi.useGetResourcesQuery({ locale });
}
